import {
  Tabs,
  Drawer,
} from "antd";
import React, {
  forwardRef,
  useState,
  useRef,
  useImperativeHandle,
  useEffect
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import "./InsuranceVPH.scss";
import moment from "moment";
import commonFn from "@/utils/commonFn";
import PropDetailModal from "@/views/AccountPayable/BusinessLicense/components/PropDetailModal";
import PolicyNumber from "@/views/AccountPayable/ApprovalSummary/component/PolicyNumber";
import RemarkPopover from "@/views/AccountPayable/ApprovalSummary/component/RemarkPopover";

const MainTable = forwardRef(({amountUrl}, ref) => {

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [VPHprop, setVPHProp] = useState('')
  const [VPHList, setVPHList] = useState([])
  const [VPHGLAcct, setVPHGLAcct] = useState([])
  const [tabsKey, setTabsKey] = useState("1");
  const [propRecord, setPropRecord] = useState({});
  const cashFlowListInit = [
    {title: "This Month Cash Flow", key: 'month'},
    {title: "This Year Cash Flow", key: 'year'},
    {title: "Pending Submission", key: 'Pending Submission'},
  ]
  const [cashFlowList, setCashFlowList] = useState(cashFlowListInit)

  useImperativeHandle(ref, () => ({
    setModalOpen: ({record}) => {
      setPropRecord(record)
      viewPaymentHAmountFn(record)
      ASInsuranceCashFlowFn(record)
      setTabsKey("1")
      setDrawerOpen(true)
    }
  }));

  const viewPaymentHAmountFn = async(record) => {
    const response = await http.get(amountUrl, { params: {propId: record?.propId} });
    if (response?.code === "1") {
      setVPHProp(response.data?.prop || '')
      setVPHList(response.data?.yearGroups || [])
      setVPHGLAcct(response.data?.pendingInsuranceGlAcctGroups || [])
    }
  }

  const ASInsuranceCashFlowFn = async(record) => {
    const response = await http.get(api.ASInsuranceCashFlow, { params: {propId: record?.propId, amount: record?.amount} });
    if (response?.code === "1") {
      setCashFlowList(cashFlowList.map(item => ({
        ...item,
        ...response.data[item.key]
      })))
    } else {
      commonFn.modalFailedFn(response);
    }
  }

  const propDetailModalRef = useRef(null);

  const viewPaymentHUnitFn = async(record) => {
    propDetailModalRef.current?.openModal({
      modalName: 'View Property Detail',
      propId: record?.propId,
      isModal: false
    });
  }
  
  useEffect(() => {
    if(tabsKey === "2"){
      viewPaymentHUnitFn(propRecord)
    }
  }, [tabsKey])

  const ViewPaymentHistoryDoc = () => {
    const amountDoc = (
      <>
        {VPHListDOC(VPHList, true)}
        {CashFlowDoc()}
      </>
    )

    const unitDoc = (
      <div style={{maxWidth: "60vw"}}>
        <PropDetailModal
          ref={propDetailModalRef}
          detailUrl={api.ASInsurancePropDetails}
          tableUrl={api.ASInsuranceUnitDetails}
        />
      </div>
    )

    return (
      <Drawer
        title="View Payment History"
        placement="right"
        rootClassName="ASInsuranceDrawer"
        closable={false}
        onClose={() => (setVPHProp(''), setVPHList([]), setVPHGLAcct([]), setCashFlowList(cashFlowListInit), setDrawerOpen(false))}
        open={drawerOpen}
      >
        <div className="ASIDTitle">Prop：{VPHprop}</div>
        <Tabs
          activeKey={tabsKey}
          items={[
            {
              key: "1",
              label: "Payment History",
              forceRender: true,
              children: amountDoc,
            },
            {
              key: "2",
              label: "Unit Information",
              forceRender: true,
              children: unitDoc,
            },
          ]}
          onChange={(key) => setTabsKey(key)}
        />
      </Drawer>
    )
  }

  const VPHListDOC = (list = [], flag) => {
    return (
      <div className="ASIDList">
        {list.map(item => (
          <div className="ASIDItem">
            <div className="ASIDItemTotal">
              <div className="ASIDItemTopYear">
                {commonFn.iconDocFn({iconKey: "ASIDYear", width: 24, height: 24, marginRight: 4})}
                {flag ? item.year : 
                  <div>
                    <div>Pending</div>
                    <div className="ASIDItemTopAmountValue">{commonFn.amountToDollarFn(item.currentYearWithPendingTotal)}</div>
                  </div>
                }
              </div>
              <div className="ASIDItemTopAmount">
                <div className="ASIDItemTopAmountName">
                  {flag ? 'Total amount' : 'Total'}
                </div>
                <div className="ASIDItemTopAmountValue font20">
                  {commonFn.amountToDollarFn(item.yearTotal)}
                </div>
                {(flag ? item?.showYearAverage : item?.showCurrentYearWithPendingAverage) && <>
                  <div className="ASIDItemTopAmountName">
                    Per Unit
                  </div>
                  <div className="ASIDItemTopAmountValue">
                    {commonFn.amountToDollarFn(flag ? item.yearAverage : item.currentYearWithPendingAverage)}
                  </div>
                </> || null}
              </div>
            </div>
            <div className="ASIDItemGlAcctList">
                {
                  item?.glAcctGroups?.length && item.glAcctGroups.map(value => (
                    <div className="ASIDItemGlAcctItem">
                      <div className="ASIDItemGlAcctItemTotal">
                        {commonFn.iconDocFn({iconKey: "ASIDGlacct", width: 20, height: 20, marginRight: 4})}
                        <span className="ASIDItemGlAcctItemName">{value.glAcct}</span>
                        <span className="ASIDItemGlAcctItemAmount">
                          {commonFn.amountToDollarFn(value.yearGlTotal)}
                        </span>
                      </div>
                      {value?.batches?.length && <div className="ASIDItemGlAcctItemBatcheList">
                        {
                          value?.batches.map(v => (
                            <div className="ASIDItemGlAcctItemBatcheItem">
                              <RemarkPopover propRecord={v}>
                                <span>{moment([v.pushTime[0], v.pushTime[1] - 1, v.pushTime[2]]).format('MM/DD/YYYY')}</span>
                              </RemarkPopover>
                              <PolicyNumber 
                                propRecord={propRecord}
                                v={v}
                              />
                              <RemarkPopover propRecord={v}>
                                <span>{commonFn.amountToDollarFn(v.amount)}</span>
                              </RemarkPopover>
                            </div>
                          ))
                        }
                      </div> || null}
                    </div>
                    )) || <div className="ASIDItemGlAcctNoData">No Data</div>
                }
            </div>
          </div>
        ))}
      </div>
    )
  }

  const CashFlowDoc = () => {
    return (
      <div className="CashFlow">
        {cashFlowList.map(cashFlow => (
          <div className="CashFlowItem">
            <div className="CashFlowTitle">
              {cashFlow.title}
            </div>
            {cashFlow.key === 'Pending Submission' ? VPHListDOC(VPHGLAcct) : <div className="CashFlowMain">
              <div className="CashFlowMainTop">
                {[
                  { name: 'Eviction', key: 'evictionTenant', iconKey: "ASIDEviction" },
                  { name: 'Vacant', key: 'vacancyUnit', iconKey: "ASIDVacant" },
                  { name: 'Gross Rent', key: 'grossRentStr', iconKey: "ASIDIncome" },
                  { name: 'Vacancy', key: 'vacancyStr', iconKey: "ASIDVacancy" },
                  // { name: 'Income', key: 'income', iconKey: "ASIDIncome", isAmount: true },
                ].map(item => (
                  <div className="CashFlowMainTopItem">
                    <div>{commonFn.iconDocFn({iconKey: item.iconKey, width: 24, height: 24})}</div>
                    <div className="TopItemName">{item.name}</div>
                    <div className="TopItemValue">{cashFlow[item.key]}</div>
                  </div>
                ))
                }
              </div>
              <div className="CashFlowMainCenter">
                {[
                  { 
                    title: 'Income',
                    amountKey: 'incomeStr',
                    list:[
                      // {name: 'Vacancy', value: 'vacancyStr'},
                      {name: 'Rent', value: 'rentStr'},
                      {name: 'Other Income', value: 'otherIncomeStr'},
                    ]
                  },
                  { 
                    title: 'Expense',
                    amountKey: 'expenseStr',
                    list:[
                      {name: 'Utility', value: 'utilityStr'},
                      {name: 'Operating', value: 'operatingStr'},
                      {name: 'Debt Service', value: 'debtServiceStr'},
                    ]
                  },
                ].map(item => (
                  <div className="CFMCenterHalf">
                    <div className={`CFMCenterTitle ${item.title === 'Expense' && "CFMCenterTitle1" || ''}`}>
                      {item.title}
                    </div>
                    <div className="CFMCenterAmount">{cashFlow[item.amountKey]}</div>
                    {item.list.map(v => <div className="CFMCenterName">{v.name}<span className="CFMCenterValue">{cashFlow[v.value]}</span></div>)}
                  </div>
                ))}
  
              </div>
              <div className="CashFlowMainBottom">
                <div className="CFMBottomDesc">
                  <div className="CFMBottomDescItem">
                    <div className="CFMBottomName">Cash Flow</div>
                    <div className="CFMBottomAmount">{cashFlow.cashFlowStr}</div>
                  </div>
                  <div className="CFMBottomDescItem">
                    <div className="CFMBottomName">Payment</div>
                    <div className="CFMBottomAmount">{cashFlow.paymentStr}</div>
                  </div>
                </div>
                <div className="CFMBottomResult">
                  {commonFn.iconDocFn({iconKey: "ASIDCashFlow", width: 36, height: 36, imageStyle: {margin: '12px 10px 12px 12px', boxSizing: 'border-box'}})}
                  <div className="CFMBottomTotal">
                    <div className="CFMBottomTotalName">Cash Flow</div>
                    <div className="CFMBottomTotalAmount">{cashFlow.cashFlowFinalStr}</div>
                  </div>
                </div>
              </div>
            </div>}
          </div>
        ))}
      </div>
    )
  }
  
  return (
    <div>
      {ViewPaymentHistoryDoc()}
    </div>
  );
});
export default MainTable;